<section class="messaging-inbox-page">
  <header class="hero">
    <div>
      <p class="eyebrow">Messaging</p>
      <h1>Inbox</h1>
      <!-- <p class="subtitle">Thread state comes from the messaging backend and Firebase. Message bodies are retrieved from
        FHIR Communication.</p> -->
    </div>

    <div class="hero-actions">
      <button mat-flat-button color="primary" type="button" (click)="startDirectMessage()">
        <mat-icon>message</mat-icon>
        New Direct Message
      </button>
    </div>

    @if (counts$ | async; as counts) {
    <div class="count-grid">
      <mat-card class="stat-card">
        <span class="stat-label">Unread Threads</span>
        <strong>{{ counts.unreadThreadCount }}</strong>
      </mat-card>
      <mat-card class="stat-card">
        <span class="stat-label">Unread Notifications</span>
        <strong>{{ counts.unreadNotificationCount }}</strong>
      </mat-card>
    </div>
    }
  </header>

  <div class="content-grid">
    <section>
      <h2>Threads</h2>
      @if (threads$ | async; as threads) {
      @if (threads.length) {
      <div class="thread-list">
        @for (thread of threads; track thread.threadId) {
        <button type="button" class="thread-card" (click)="openThread(thread)">
          <div class="thread-card-top">
            <div>
              <h3>{{ thread.title || thread.threadType || 'Untitled thread' }}</h3>
              <p>{{ thread.lastMessagePreview || 'No messages yet' }}</p>
            </div>
            @if (thread.unreadCount > 0) {
            <span class="badge unread">{{ thread.unreadCount }}</span>
            }
          </div>
          <div class="thread-card-bottom">
            <span>{{ (thread.lastMessageAt || thread.updatedAt) | date:'medium' }}</span>
            @if (thread.context?.contextType || thread.context?.contextId) {
            <button type="button" class="context-link" (click)="openContext(thread, $event)">
              <mat-icon>open_in_new</mat-icon>
              <span>{{ thread.context?.contextType || 'Context' }} {{ thread.context?.contextId || '' }}</span>
            </button>
            }
          </div>
        </button>
        }
      </div>
      } @else {
      <mat-card class="empty-card">
        <mat-icon>forum</mat-icon>
        <p>No threads found.</p>
      </mat-card>
      }
      } @else {
      <div class="loading-state"><mat-spinner diameter="32"></mat-spinner></div>
      }
    </section>

    <aside>
      <h2>Recent Notifications</h2>
      @if (notifications$ | async; as notifications) {
      @if (notifications.length) {
      <div class="notification-list">
        @for (notification of notifications.slice(0, 8); track notification.notificationId) {
        <button type="button" class="notification-card" (click)="openNotification(notification)">
          <div class="notification-header">
            <span>{{ notification.type }}</span>
            @if (notification.status !== 'read') {
            <span class="badge status">{{ notification.status }}</span>
            }
          </div>
          <p>{{ notification.preview }}</p>
          <small>{{ notification.createdAt | date:'medium' }}</small>
        </button>
        }
      </div>
      } @else {
      <mat-card class="empty-card">
        <mat-icon>notifications</mat-icon>
        <p>No notifications found.</p>
      </mat-card>
      }
      }
    </aside>
  </div>
</section>